
// action - snackbar
export const SNACKBAR_OPEN = '@snackbar/SNACKBAR_OPEN';
export const SNACKBAR_CLOSE = '@snackbar/SNACKBAR_CLOSE';

// action - app
export const APP_ACCEPT_COOKIES = '@snackbar/APP_ACCEPT_COOKIES';
